import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="property-form"
export default class extends Controller {
  static targets = ["ruralFields", "urbanFields", "anualTypeRadio"]

  connect() {
    this.updateVisibility()
  }

  typeChanged() {
    this.updateVisibility()
  }

  updateVisibility() {
    const selectedType = this.anualTypeRadioTargets.find(r => r.checked)?.value
    const isRural = selectedType === "rural"
    this.ruralFieldsTarget.classList.toggle("hidden", !isRural)
    this.urbanFieldsTarget.classList.toggle("hidden", isRural)
  }
}
